/* The magnifier in the header opens Grandseal's own search bar rather than
   Horizon's predictive-search dialog.

   Whatever page you are on, it goes to the search band on that page — the one
   under the hero at home, the one above the grid on the products page. Any
   other page has no band, so it sends you to the products page and the band
   there focuses itself from the #gs-search hash.

   THE BUTTON IS REPLACED, not intercepted. Horizon wires its dialog up with an
   on:click="#search-modal/showDialog" attribute handled by the theme's own
   delegated listener, which runs before anything this file could add — a
   capture-phase listener on document was not enough and the dialog kept
   opening. Swapping in a fresh button with no attribute leaves nothing for
   that listener to find. The header gets rebuilt on some navigations, so the
   swap re-runs on a MutationObserver watching the header alone.

   GETTING THERE has three attempts, tried IN SEQUENCE and each skipped if the
   band is already on screen: scrollIntoView, then moving Horizon's
   .page-wrapper scroller by hand, then the #gs-search hash. They have to be
   sequential — running the second while the first was still animating
   measured a stale position and threw the page halfway down the home page. */

(function () {
  'use strict';

  var TRIGGER = '.search-action button, search-button button';

  function band() {
    var box = document.querySelector('[data-gs-search]');
    if (box && !box.id) box.id = 'gs-search';
    return box;
  }

  function near(box) {
    var top = box.getBoundingClientRect().top;
    return top > -80 && top < window.innerHeight * 0.75;
  }

  function nudge(box, smooth) {
    if (near(box)) return;

    var rect = box.getBoundingClientRect();
    var how = smooth ? 'smooth' : 'auto';
    var pane = document.querySelector('.page-wrapper');

    if (pane && pane.scrollHeight > pane.clientHeight + 4) {
      var to = pane.scrollTop + rect.top - Math.max((pane.clientHeight - rect.height) / 2, 80);
      try { pane.scrollTo({ top: to, behavior: how }); } catch (err) { pane.scrollTop = to; }
      return;
    }

    var doc = document.scrollingElement || document.documentElement;
    var y = doc.scrollTop + rect.top - Math.max((window.innerHeight - rect.height) / 2, 80);
    try { window.scrollTo({ top: y, behavior: how }); } catch (err) { doc.scrollTop = y; }
  }

  function ring(box) {
    box.classList.add('gs-ping');
    window.setTimeout(function () { box.classList.remove('gs-ping'); }, 1400);
  }

  function focusBand(smooth) {
    var box = band();
    if (!box) return false;

    try {
      box.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
    } catch (err) {
      box.scrollIntoView();
    }

    window.setTimeout(function () { nudge(box, smooth); }, smooth ? 700 : 90);

    window.setTimeout(function () {
      if (!near(box)) window.location.hash = 'gs-search';
    }, smooth ? 1500 : 320);

    var input = box.querySelector('[data-gs-input]');

    window.setTimeout(function () {
      if (input) {
        try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
      }
      ring(box);
    }, smooth ? 820 : 90);

    return true;
  }

  function jump(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!focusBand(true)) window.location.href = '/pages/products#gs-search';
  }

  function swap(old) {
    if (old.dataset.gsJump === '1') return;

    var fresh = document.createElement('button');
    fresh.type = 'button';
    fresh.className = old.className;
    fresh.innerHTML = old.innerHTML;
    fresh.dataset.gsJump = '1';
    fresh.setAttribute('aria-label', old.getAttribute('aria-label') || 'Search');

    fresh.addEventListener('click', jump);

    if (old.parentNode) old.parentNode.replaceChild(fresh, old);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll(TRIGGER), swap);
  }

  /* Belt and braces: anything that still reaches a search trigger — a link to
     /search, say — is caught here before it can do anything. */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('.gs-search, dialog[open]')) return;

      var hit = event.target.closest('.search-action, search-button, a[href^="/search"]');
      if (!hit) return;

      jump(event);
    },
    true
  );

  function watch() {
    if (!('MutationObserver' in window)) return;

    var host = document.querySelector('header-component, #header-component, .header, header');
    if (!host) return;

    var pending = null;
    new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(scan, 120);
    }).observe(host, { childList: true, subtree: true });
  }

  function start() {
    band();
    scan();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.setTimeout(scan, 900);
  window.setTimeout(scan, 2500);

  if (window.location.hash === '#gs-search') {
    window.setTimeout(function () { focusBand(false); }, 500);
  }
})();
